export default "__VITE_ASSET__BDwhv5fX__"